export default "/packs/images/general~cfdebbf820049a2fa3c44b87d29ffffe.svg";